export type Language = {
  value: string;
  text: string;
};

export const defaultLanguages: Language[] = [
  {
    value: 'swe',
    text: 'Swedish',
  },
  {
    value: 'eng',
    text: 'English',
  },
  {
    value: 'ara',
    text: 'Arabic',
  },
  {
    value: 'ukr',
    text: 'Ukrainian',
  },
  {
    value: 'nor',
    text: 'Norwegian',
  },
  {
    value: 'fin',
    text: 'Finnish',
  },
  {
    value: 'fra',
    text: 'French',
  },
];
